import React, { memo } from 'react';
import { lowercaseSpiranteMutations } from './spiranteMutations';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import BtnSongTriFemoch from './BtnSongTriFemoch';
import ListSubTitle from './ListSubTitle';
import ListParagraph from './ListParagraph';

const ExplanationSpiranteMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseSpiranteMutations} mutationType={mutationTypes.SPIRANTE}>
      <ul>
        <li>
          <ListSubTitle>ma/he/hon/o/em</ListSubTitle>
          <ListParagraph>
            Pelec'h emañ ma c'hi?<br />
            Atav e ra diouzh he fenn. (Elle n'en fait qu'à sa tête)<br />
            Poan am eus em fenn.<br />
            Yec'hed mat ma zud!<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>tri/teir/pevar/peder/nav</ListSubTitle>
          <ListParagraph>
            tri c'horn.<br />
            teir flac'h.<br />
            nav zra.<br />
            <BtnSongTriFemoch />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>particules verbales: <em>em/am</em></ListSubTitle>
          <ListParagraph>
            em zapout. (m'attraper)<br />
            am c'harout. (m'aimer)<br />
            am faeañ. (me payer)<br />
          </ListParagraph>
        </li>
      </ul>
    </ExplanationMutation>
  );
};

export default memo(ExplanationSpiranteMutation);
